module.exports = __webpack_public_path__ + "img/car.951ff8e4.png";